import Styled from 'styled-components';

const StyledProductQnA = Styled.div`
  margin: 32px;
  margin-top: ${(props) => (props.isPDPRedesignEnabled ? `0` : `32px`)};
`;

export default StyledProductQnA;
